<template>
    <td>
        <b-btn v-tooltip="'Vetésváltás ellenörzése.'"
               v-on:click="validateKetRow()"
               class='btn btn-sm  btn-success btn-block btn-row-validation'>
            <i class="fa fa-check"
               aria-hidden="true"
               style="color:white"></i>
        </b-btn>
    </td>
</template>

<script>
import swal from "sweetalert2";

export default {
  props: ["ketRowId"],

  data() {
    return {
      form: new Form({
        ketRowId: ""
      })
    };
  },

  methods: {
    validateKetRow() {
      this.form.ketRowId = this.ketRowId;
      this.form
        .post("ajax/rows/check")
        .then(function(response) {
          if (response.status == "notValid") {
            swal({
              type: "error",
              title: "Van néhány hiba!",
              html: response.body,
              confirmButtonColor: "#3fa535",
              confirmButtonText: "Rendben"
            });
          }
          if (response.status == "valid") {
            swal({
              type: "success",
              title: "Ok!",
              html: response.body,
              confirmButtonColor: "#3fa535",
              confirmButtonText: "Rendben"
            });
          }
        })
        .catch(e => {
          var text = "";
          var array = $.map(e.errors, function(value, index) {
            text = text + value;
          });
          swal("Hiba!", text, "error");
        });
    }
  }
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/ValidateKetRow.vue